import { User, UserRole } from "api";

export const getDefaultLabelForProjectsSelect = (role?: User["role"]): string =>
  role === UserRole.Pm ? "Všechny moje projekty" : "Všechny projekty";
